import React from 'react'

import PropTypes from 'prop-types'

import fallbackImage from '@shared/assets/default-placeholder.png'

const Image = ({ src, alt, srcFallback = '', ...props }) => (
  <img
    src={src || fallbackImage}
    alt={alt}
    onError={
      (evt) => {
        evt.target.onerror = null
        evt.target.src = srcFallback || fallbackImage
      }
    }
    {...props}
  />
)

Image.propTypes = {
  src: PropTypes.string.isRequired,
  srcFallback: PropTypes.string,
  alt: PropTypes.string
}

export default Image
